import { FiltersTypes } from "@common/types/filters/general";
import { TaskListQuery } from "@common/contracts/task.contract";
import { TaskStatus } from "@common/types/task";
import { User, UserType } from "@common/types/user";
import { DEFAULT_VIEW_ID } from "@components/views/constants";
import { DEFAULT_TASK_LIST_QUERY } from "./taskListConstants";
import {
    ASSIGNED_TO_ME_TASK_LIST_QUERY,
    ASSIGNED_TO_ME_VIEW_ID,
    buildAssignedToMeOverlayFilters,
    MONTH_END_CLOSE_TASK_LIST_QUERY,
    MONTH_END_CLOSE_VIEW_ID,
} from "./views/OrganizationTaskViews";

/** The view and filters a Tasks page's content mounts with. */
export interface TasksLanding {
    landingViewId: string | undefined;
    defaultQuery: TaskListQuery;
    initialOverlayFilters: FiltersTypes | undefined;
}

export const buildAssignedToMeLanding = (userId: number): TasksLanding => ({
    landingViewId: ASSIGNED_TO_ME_VIEW_ID,
    defaultQuery: ASSIGNED_TO_ME_TASK_LIST_QUERY,
    initialOverlayFilters: buildAssignedToMeOverlayFilters(userId),
});

/** All tasks, on the statuses the page builds the view with, so it opens unedited. */
const buildAllTasksLanding = (
    defaultStatuses: TaskStatus[] | undefined,
): TasksLanding => ({
    landingViewId: DEFAULT_VIEW_ID,
    defaultQuery: { ...DEFAULT_TASK_LIST_QUERY, status: defaultStatuses },
    initialOverlayFilters: undefined,
});

/**
 * A first visit with no page-specific view to open: Assigned to me, or All
 * tasks for support users, who aren't members. `defaultStatuses` are the
 * page's, from its task list capabilities.
 */
export const buildFirstVisitLanding = ({
    user,
    defaultStatuses,
}: {
    user: Pick<User, "id" | "type">;
    defaultStatuses: TaskStatus[] | undefined;
}): TasksLanding =>
    user.type === UserType.SUPPORT
        ? buildAllTasksLanding(defaultStatuses)
        : buildAssignedToMeLanding(user.id);

export const MONTH_END_CLOSE_LANDING: TasksLanding = {
    landingViewId: MONTH_END_CLOSE_VIEW_ID,
    defaultQuery: MONTH_END_CLOSE_TASK_LIST_QUERY,
    initialOverlayFilters: undefined,
};
